import { FilteredItemProps } from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { GetTariffsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/tariffs/get-tariffs-paginated.model';
import { ColumnOrderState, VisibilityState } from '@tanstack/react-table';

import { EmspBoCpoFilterStateController } from '@app/feature/emsp-bo-cpo/emsp-bo-cpo-filter-state/emsp-bo-cpo-filter-state.controller';

import { EmspBoTariffCreatedAfterFilterStateController } from '../emsp-bo-tariff-created-after-filter-state/emsp-bo-tariff-created-after-filter-state.controller';
import { EmspBoTariffCreatedBeforeFilterStateController } from '../emsp-bo-tariff-created-before-filter-state/emsp-bo-tariff-created-before-filter-state.controller';
import { EmspBoTariffIdFilterStateController } from '../emsp-bo-tariff-id-filter-state/emsp-bo-tariff-id-filter-state.controller';
import { EmspBoTariffUpdatedAfterFilterStateController } from '../emsp-bo-tariff-updated-after-filter-state/emsp-bo-tariff-updated-after-filter-state.controller';
import { EmspBoTariffUpdatedBeforeFilterStateController } from '../emsp-bo-tariff-updated-before-filter-state/emsp-bo-tariff-updated-before-filter-state.controller';

export const EMSP_BO_TARIFF_LIST_SORT_FIELD: NonNullable<
  GetTariffsPaginatedModel['sortField']
> = 'updatedAt';

export const EMSP_BO_TARIFF_LIST_SORT_ORDER: NonNullable<
  GetTariffsPaginatedModel['sortOrder']
> = -1;

type ResourceListFilter = Partial<
  Record<
    keyof GetTariffsPaginatedModel,
    {
      componentType?: React.ComponentType<{
        value: any;
        onRemove: FilteredItemProps['onRemove'];
      }>;
    }
  >
>;

export const EMSP_BO_TARIFF_LIST_FILTER: ResourceListFilter = {
  cpoId: {
    componentType: EmspBoCpoFilterStateController,
  },
  id: {
    componentType: EmspBoTariffIdFilterStateController,
  },
  createdAfter: {
    componentType: EmspBoTariffCreatedAfterFilterStateController,
  },
  createdBefore: {
    componentType: EmspBoTariffCreatedBeforeFilterStateController,
  },
  updatedAfter: {
    componentType: EmspBoTariffUpdatedAfterFilterStateController,
  },
  updatedBefore: {
    componentType: EmspBoTariffUpdatedBeforeFilterStateController,
  },
} as const;

export const EMSP_BO_TARIFF_LIST_FILTER_NAME_LIST = Object.keys(
  EMSP_BO_TARIFF_LIST_FILTER,
) as Array<keyof typeof EMSP_BO_TARIFF_LIST_FILTER>;

// /////////////////////////////////////////////////////////////////////////////
// DISPLAYING
// /////////////////////////////////////////////////////////////////////////////

export const EMSP_BO_TARIFF_LIST_COLUMN_ID_LIST = [
  'id',
  'currency',
  'last_updated',
] as const;

export const EMSP_BO_TARIFF_LIST_COLUMN_ORDER: ColumnOrderState = [
  ...EMSP_BO_TARIFF_LIST_COLUMN_ID_LIST,
];

export const EMSP_BO_TARIFF_LIST_COLUMN_VISIBILITY: VisibilityState =
  EMSP_BO_TARIFF_LIST_COLUMN_ID_LIST.reduce(
    (acc, id) => ({ ...acc, [id]: true }),
    {} as VisibilityState,
  );

// /////////////////////////////////////////////////////////////////////////////
// OPTIONS
// /////////////////////////////////////////////////////////////////////////////

export interface EmspBoTariffListOptionsModel {
  columnVisibility: VisibilityState;
  columnOrder: ColumnOrderState;
}

export const EMSP_BO_TARIFF_LIST_DEFAULT_OPTIONS: EmspBoTariffListOptionsModel =
  {
    columnVisibility: EMSP_BO_TARIFF_LIST_COLUMN_VISIBILITY,
    columnOrder: EMSP_BO_TARIFF_LIST_COLUMN_ORDER,
  };

export const EMSP_BO_TARIFF_LIST_COLUMN_LABEL_I18N_KEY: Record<string, string> =
  {
    id: 'delmonicos-shared-sdk.ocpi-cpo-api-models-tariff.id',
    currency: 'delmonicos-shared-sdk.ocpi-cpo-api-models-tariff.currency',
    last_updated:
      'delmonicos-shared-sdk.ocpi-cpo-api-models-tariff.last-updated',
  };
